import { Injectable } from '@angular/core';
import { StockKeepingUnitQuantityList } from '../global/types/SKU';
import { HqStop } from '../global/interfaces/hqStop';
import { StockKeepingUnitOveragesReasons, StockKeepingUnitRejectionReasons } from '../global/enums/StockKeepingUnit';

@Injectable()
export class StockKeepingUnitFunctions {
  skuRejectionReasonTypeToStringMap = new Map([
    [StockKeepingUnitRejectionReasons.DAMAGED_GOODS, 'Damaged goods'],
    [StockKeepingUnitRejectionReasons.LATE_TO_DELIVERY, 'Late Arrival'],
    [StockKeepingUnitRejectionReasons.GOODS_REFUSED, 'Goods Refused'],
    [StockKeepingUnitRejectionReasons.PRODUCT_NOT_AVAILABLE, 'Product Not Available'],
    [StockKeepingUnitRejectionReasons.SHORTAGE, 'Shortage'],
    [StockKeepingUnitRejectionReasons.OTHER, 'Other'],
  ]);
  skuOveragesReasonTypeToStringMap = new Map([
    [StockKeepingUnitOveragesReasons.OVER_ORIGINAL_ORDERED_QUANTITY, 'Over original ordered quantity'],
    [StockKeepingUnitOveragesReasons.OTHER, 'Other'],
  ]);
  constructor() {}

  getSkuCount(skuLists: StockKeepingUnitQuantityList[]): number {
    return skuLists?.reduce<number>((total, skuList) => total + (skuList?.stockKeepingUnitQuantities?.length ?? 0), 0);
  }

  getSkuQuantityForList(skuList: StockKeepingUnitQuantityList): number {
    return skuList?.stockKeepingUnitQuantities?.reduce((total, item) => total + item?.quantity ?? 0, 0);
  }

  getTotalQuantity(skuLists: StockKeepingUnitQuantityList[]): number {
    return skuLists?.reduce<number>(
      (totalQuantity, skuList) => totalQuantity + (this.getSkuQuantityForList(skuList) ?? 0),
      0,
    );
  }

  getStopKeepingUnitQuantityLists(stops: HqStop[]): StockKeepingUnitQuantityList[] {
    return stops.map((stop) => stop.stockKeepingUnitQuantityList);
  }

  skuRejectionReasonsToString(value: StockKeepingUnitRejectionReasons): string {
    return this.skuRejectionReasonTypeToStringMap.get(value);
  }

  skuOveragesReasonsToString(value: StockKeepingUnitOveragesReasons): string {
    return this.skuOveragesReasonTypeToStringMap.get(value);
  }
}
